var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "t-panel"
    }
  }, [_c('div', {
    class: ['t-panel-wrapper', _vm.panelCss]
  }, [_c('div', {
    ref: "panel",
    staticClass: "t-panel-container"
  }, [_c('v-touch', {
    attrs: {
      "swipeOptions": {
        direction: 'horizontal'
      }
    },
    on: {
      "swipeleft": function swipeleft($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "t-panel-bounds"
  }, [_vm.showCloseIcon ? _c('ButtonPush', {
    staticClass: "t-panel-close",
    attrs: {
      "icon": "icon-close",
      "spin": "icon-only"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" Close ")]) : _vm._e(), _vm._t("default")], 2)])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }